import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-14aa5550"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "bar-title"
}, "首页", -1));
const _hoisted_2 = ["src"];
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "bar-title"
}, "资讯", -1));
const _hoisted_4 = ["src"];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "bar-title"
}, "资助项目", -1));
const _hoisted_6 = ["src"];
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "bar-title"
}, "志愿者服务", -1));
const _hoisted_8 = ["src"];
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "bar-title"
}, "我的", -1));
const _hoisted_10 = ["src"];
import { ref } from 'vue';
import { showToast } from 'vant';
import { testStatus } from '@/config/comm';
export default {
  __name: 'FootNav',
  setup(__props) {
    const active = ref(0);
    const icon = {
      inactive1: require('../assets/img/bar/home.png'),
      active1: require('../assets/img/bar/home-active.png'),
      inactive2: require('../assets/img/bar/news.png'),
      active2: require('../assets/img/bar/news-active.png'),
      inactive3: require('../assets/img/bar/project.png'),
      active3: require('../assets/img/bar/project-active.png'),
      inactive4: require('../assets/img/bar/serve.png'),
      active4: require('../assets/img/bar/serve-active.png'),
      inactive5: require('../assets/img/bar/mine.png'),
      active5: require('../assets/img/bar/mine-active.png')
    };
    const onChange = index => {
      if (testStatus && index == '3') return showToast('功能暂未开放！');
      active.value = index;
    };
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      const _component_van_tabbar_item = _resolveComponent("van-tabbar-item");
      const _component_van_tabbar = _resolveComponent("van-tabbar");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_router_view), !_ctx.$route.meta.hideTabBar ? (_openBlock(), _createBlock(_component_van_tabbar, {
        key: 0,
        route: "",
        placeholder: true,
        modelValue: active.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => active.value = $event),
        onChange: onChange
      }, {
        default: _withCtx(() => [_createVNode(_component_van_tabbar_item, {
          to: "/home"
        }, {
          icon: _withCtx(props => [_createElementVNode("img", {
            src: props.active ? icon.active1 : icon.inactive1
          }, null, 8, _hoisted_2)]),
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _createVNode(_component_van_tabbar_item, {
          to: "/news"
        }, {
          icon: _withCtx(props => [_createElementVNode("img", {
            src: props.active ? icon.active2 : icon.inactive2
          }, null, 8, _hoisted_4)]),
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }), _createVNode(_component_van_tabbar_item, {
          to: "/crowdfundingIndex"
        }, {
          icon: _withCtx(props => [_createElementVNode("img", {
            src: props.active ? icon.active3 : icon.inactive3
          }, null, 8, _hoisted_6)]),
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        }), _createVNode(_component_van_tabbar_item, {
          to: _unref(testStatus) ? '' : '/volunteerIndex',
          class: _normalizeClass({
            'disabled': _unref(testStatus)
          })
        }, {
          icon: _withCtx(props => [_createElementVNode("img", {
            src: props.active ? icon.active4 : icon.inactive4
          }, null, 8, _hoisted_8)]),
          default: _withCtx(() => [_hoisted_7]),
          _: 1
        }, 8, ["to", "class"]), _createVNode(_component_van_tabbar_item, {
          to: "/mine"
        }, {
          icon: _withCtx(props => [_createElementVNode("img", {
            src: props.active ? icon.active5 : icon.inactive5
          }, null, 8, _hoisted_10)]),
          default: _withCtx(() => [_hoisted_9]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])) : _createCommentVNode("", true)]);
    };
  }
};